import React, { useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { InputHandler } from '../../../../../viewer/input-handler';
import { IntersectionTool } from '../../../../../viewer/tools/intersection-tool';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { ToolIcon } from '../tool-icon';

const IntersectionToolIcon = () => {
  const { t } = useTranslation();
  const { activeTool, skyview } = useContext(SkyviewContext);
  const isActive = useMemo(() => activeTool instanceof IntersectionTool, [activeTool]);

  useEffect(() => {
    if (activeTool instanceof IntersectionTool) {
      activeTool.webGlRenderer = skyview.renderer;
    }
  }, [activeTool, skyview]);

  return (
    <ToolIcon
      active={isActive}
      callback={() => InputHandler.instance.setTool('intersection')}
      icon={['fal', 'scissors']}
      tooltip={{
        title: t('intersectionTool.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('intersectionTool.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    />
  );
};

export { IntersectionToolIcon };
